// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-bookkeeper",
 "roleDisplay": "AI Bookkeeper",
 "phrase": "ai bookkeeper",
 "seo": {
  "title": "AI Bookkeeper: Categorizes, Reconciles, Closes | CellCog",
  "description": "An AI bookkeeper that categorizes transactions, reconciles your accounts, chases overdue invoices and hands your accountant clean books each month."
 },
 "painSub": "The books slip a month, then a quarter, and tax season turns into an emergency. Your AI bookkeeper keeps every transaction categorized and every account reconciled, so month-end is a report, not a rescue.",
 "definition": "An AI bookkeeper is an AI employee that categorizes transactions, reconciles bank and card accounts, tracks invoices and bills, and runs your month-end close. On CellCog they are hired in minutes, work in QuickBooks or your spreadsheets, and are built on the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · TRANSACTIONS",
   "title": "Categorizes your transactions.",
   "sub": "Each line matched to your chart of accounts, with the unclear ones flagged.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--table\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Transactions</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>September transactions</b><span>412 categorized, 4 flagged</span></div><div class=\"rf-panel\"><table class=\"rf-table\"><thead><tr><th scope=\"col\">Date</th><th scope=\"col\">Payee</th><th scope=\"col\">Category</th><th scope=\"col\" class=\"rf-num\">Amount</th></tr></thead><tbody><tr><td data-label=\"Date\">Sep 28</td><td data-label=\"Payee\">Riverside Roasters</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-blue\">Inventory: beans</span></td><td data-label=\"Amount\" class=\"rf-num\">-1,240.00</td></tr><tr><td data-label=\"Date\">Sep 28</td><td data-label=\"Payee\">Card deposits</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-green\">Sales</span></td><td data-label=\"Amount\" class=\"rf-num\">+3,812.50</td></tr><tr><td data-label=\"Date\">Sep 27</td><td data-label=\"Payee\">City Water</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-graphite\">Utilities</span></td><td data-label=\"Amount\" class=\"rf-num\">-186.20</td></tr><tr><td data-label=\"Date\">Sep 27</td><td data-label=\"Payee\">Valley Milk Co-op</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-blue\">Inventory: dairy</span></td><td data-label=\"Amount\" class=\"rf-num\">-412.75</td></tr><tr><td data-label=\"Date\">Sep 26</td><td data-label=\"Payee\">Bistro 22</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-amber\">Personal, flagged</span></td><td data-label=\"Amount\" class=\"rf-num\">-48.60</td></tr><tr><td data-label=\"Date\">Sep 26</td><td data-label=\"Payee\">Espresso machine lease</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-amber\">Needs review</span></td><td data-label=\"Amount\" class=\"rf-num\">-299.00</td></tr><tr><td data-label=\"Date\">Sep 25</td><td data-label=\"Payee\">Payroll</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-purple\">Payroll</span></td><td data-label=\"Amount\" class=\"rf-num\">-4,120.00</td></tr><tr><td data-label=\"Date\">Sep 24</td><td data-label=\"Payee\">Harbor Linen Supply</td><td data-label=\"Category\"><span class=\"rf-chip rf-tone-graphite\">Supplies</span></td><td data-label=\"Amount\" class=\"rf-num\">-138.40</td></tr></tbody></table><ul class=\"rf-tlist\"><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Riverside Roasters</b><span class=\"rf-chip rf-tone-blue\">Inventory: beans</span></div><span class=\"rf-tl-rest\">Sep 28 · -1,240.00</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Card deposits</b><span class=\"rf-chip rf-tone-green\">Sales</span></div><span class=\"rf-tl-rest\">Sep 28 · +3,812.50</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>City Water</b><span class=\"rf-chip rf-tone-graphite\">Utilities</span></div><span class=\"rf-tl-rest\">Sep 27 · -186.20</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Valley Milk Co-op</b><span class=\"rf-chip rf-tone-blue\">Inventory: dairy</span></div><span class=\"rf-tl-rest\">Sep 27 · -412.75</span></li></ul><div class=\"rf-tlist-more\"><p class=\"rf-sched-more\">and 4 more</p></div></div></div></div></div>"
  },
  {
   "num": "02 · MONTH END",
   "title": "Closes the month.",
   "sub": "Reconciled accounts and a plain-language P&L, ready for your accountant.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--chart\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Profit and loss</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Monthly profit and loss</b><span>Juniper Coffee, in thousands</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>10.3k</b><span>net profit, September</span><em class=\"rf-delta\">+3.2k vs August</em></div><div class=\"rf-stat\"><b>19.7%</b><span>margin</span><em class=\"rf-delta\">up from 14.6%</em></div><div class=\"rf-stat\"><b>52.3k</b><span>revenue</span><em class=\"rf-delta\">+7.6% vs August</em></div></div><div class=\"rf-panel rf-chart\"><div class=\"rf-ch-h\"><span class=\"rf-ch-t\">April to September</span><span class=\"rf-legend\"><span class=\"rf-leg rf-tone-accent\"><i></i>Revenue</span><span class=\"rf-leg rf-tone-amber\"><i></i>Expenses</span></span></div><div class=\"rf-bars\"><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:72.9%\"><span class=\"rf-sr\">Apr Revenue: 41.2</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:64.4%\"><span class=\"rf-sr\">Apr Expenses: 36.4</span></i></div><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:77.5%\"><span class=\"rf-sr\">May Revenue: 43.8</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:65.7%\"><span class=\"rf-sr\">May Expenses: 37.1</span></i></div><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:84.1%\"><span class=\"rf-sr\">Jun Revenue: 47.5</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:70.5%\"><span class=\"rf-sr\">Jun Expenses: 39.8</span></i></div><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:86.9%\"><span class=\"rf-sr\">Jul Revenue: 49.1</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:71.2%\"><span class=\"rf-sr\">Jul Expenses: 40.2</span></i></div><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:86.0%\"><span class=\"rf-sr\">Aug Revenue: 48.6</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:73.5%\"><span class=\"rf-sr\">Aug Expenses: 41.5</span></i></div><div class=\"rf-bgrp\"><i class=\"rf-bar rf-tone-accent\" style=\"height:92.6%\"><span class=\"rf-sr\">Sep Revenue: 52.3</span></i><i class=\"rf-bar rf-tone-amber\" style=\"height:74.4%\"><span class=\"rf-sr\">Sep Expenses: 42.0</span></i></div></div><div class=\"rf-xlabs\"><span>Apr</span><span>May</span><span>Jun</span><span>Jul</span><span>Aug</span><span>Sep</span></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Remembers your rules.",
   "sub": "Your chart of accounts, vendor rules and past decisions live in your Drive.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Juniper Coffee</span><i aria-hidden=\"true\">/</i><b>Finance</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Chart of accounts.xlsx</span><span class=\"rf-fmeta\">How you categorize</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">September bank statement.pdf</span><span class=\"rf-fmeta\">Reconciled</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Receipts</span><span class=\"rf-fmeta\">318 matched to transactions</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Notes for our accountant.docx</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Bean orders count as inventory, owner meals are never business, and any new vendor gets flagged for you.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before money moves.",
   "sub": "Invoices, reminders and payment runs wait for your yes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send this reminder to Hillside Bakery?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Rosa Marin</em></div><b class=\"rf-prev-t\">Invoice 1042, a friendly reminder</b><p class=\"rf-prev-b\">Hi Rosa, a quick note that invoice 1042 for the September bean delivery is 12 days past due. The payment link is below. Thank you, as always.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Reminder to Maple Grocers, invoice 1051</span><span class=\"rf-q-m\">Gmail · 21 days overdue</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Release the Friday supplier payment run</span><span class=\"rf-q-m\">3 bills · ready</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Reports on the books.",
   "sub": "What is reconciled, what is overdue and which decisions are yours.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Juniper Coffee books</b><span>Today, 6:20 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>412</b><span>categorized</span></div><div class=\"rf-stat\"><b>2</b><span>accounts reconciled</span></div><div class=\"rf-stat\"><b>4</b><span>items flagged</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Categorized 412 transactions</li><li>Reconciled both bank accounts to the penny</li><li>Matched 318 receipts</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Close September</li><li>Prepare the aging report for your accountant</li><li>Flag the new espresso machine lease for your accountant</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Check 4 flagged items before the close</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Categorizes transactions",
   "body": "Matches bank and card lines to your chart of accounts and flags the unclear ones."
  },
  {
   "title": "Reconciles accounts",
   "body": "Checks statements against the books line by line and explains each difference."
  },
  {
   "title": "Tracks invoices and bills",
   "body": "Keeps receivables and payables current and prepares payment runs for your approval."
  },
  {
   "title": "Chases overdue invoices",
   "body": "Builds the aging report and drafts polite reminders in your voice."
  },
  {
   "title": "Runs the month-end close",
   "body": "Reconciliations, accruals and a close report you can hand to your accountant."
  },
  {
   "title": "Explains the numbers",
   "body": "A monthly summary in plain words, with anything unusual called out."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a bookkeeper. Catch up last month's transactions and reconcile our checking account.\""
  },
  {
   "n": "02",
   "title": "Connect your books.",
   "body": "Add QuickBooks, or share bank exports and your spreadsheet."
  },
  {
   "n": "03",
   "title": "Review the first close.",
   "body": "They send the categorized month and what they are unsure about. You decide the rest."
  }
 ],
 "tools": [
  {
   "name": "QuickBooks",
   "logo": "https://logos.composio.dev/api/quickbooks"
  },
  {
   "name": "Excel",
   "logo": "https://logos.composio.dev/api/excel"
  },
  {
   "name": "Stripe",
   "logo": "https://logos.composio.dev/api/stripe"
  },
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  },
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  }
 ],
 "control": {
  "statement": "Money moves only with your yes.",
  "sub": "They keep the books.",
  "accent": "You approve what goes out.",
  "rows": [
   {
    "title": "Payments on your approval",
    "body": "They prepare payment runs; you approve and release them."
   },
   {
    "title": "Read-only when you want it",
    "body": "Start with read access and widen it when you are ready."
   },
   {
    "title": "Every action logged",
    "body": "Each change sits on their task board with the reason beside it."
   }
  ]
 },
 "wont": {
  "sub": "They keep your books.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No tax filings",
    "body": "Returns and filings stay with a licensed professional."
   },
   {
    "title": "No payments on their own",
    "body": "They prepare payment runs; you approve and release them."
   },
   {
    "title": "No guessing on tax-sensitive items",
    "body": "Ambiguous classifications go to you or your accountant."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to keep the books",
  "cols": [
   "Doing it yourself",
   "Accounting software alone",
   "AI Bookkeeper"
  ],
  "rows": [
   {
    "label": "Categorizes transactions",
    "cells": [
     "Evenings and weekends",
     "Rules you set up",
     "Yes, flags the unclear"
    ]
   },
   {
    "label": "Reconciles accounts",
    "cells": [
     "You",
     "Suggested matches",
     "Line by line"
    ]
   },
   {
    "label": "Chases overdue invoices",
    "cells": [
     "You",
     "Automatic reminders",
     "Drafted in your voice"
    ]
   },
   {
    "label": "Runs the month-end close",
    "cells": [
     "You",
     "No",
     "Yes, with a report"
    ]
   },
   {
    "label": "Explains the numbers",
    "cells": [
     "No",
     "Standard reports",
     "In plain words"
    ]
   },
   {
    "label": "Moves money",
    "cells": [
     "You",
     "You",
     "Only with your yes"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Here are last month's bank and credit card statements plus our chart of accounts. Categorize every transaction and flag anything you are unsure about.",
   "deliverable": "a categorized ledger with flagged exceptions"
  },
  {
   "q": "Reconcile our checking account against the books for June and list every discrepancy with your best explanation.",
   "deliverable": "a reconciliation report with discrepancy notes"
  },
  {
   "q": "Build an accounts receivable aging report and draft polite reminder emails for every invoice more than 30 days overdue.",
   "deliverable": "an AR aging report with ready-to-send reminders"
  },
  {
   "q": "Run our month-end close checklist and give me a close report: what is reconciled, what is accrued, and what needs my decision.",
   "deliverable": "a month-end close report"
  },
  {
   "q": "Prepare a monthly summary for my accountant: profit and loss, cash position and what changed versus last month.",
   "deliverable": "an accountant-ready financial package"
  }
 ],
 "faq": [
  {
   "q": "What is an AI bookkeeper?",
   "a": "An AI bookkeeper is an AI employee that categorizes transactions, reconciles bank and card accounts, tracks invoices and bills, and runs your month-end close."
  },
  {
   "q": "Which accounting tools do they work with?",
   "a": "QuickBooks through our connector, plus bank exports and spreadsheets. If your books live in a spreadsheet today, your AI bookkeeper starts there."
  },
  {
   "q": "Is it safe to give them our financials?",
   "a": "You control access. They can work read-only, and anything that sends money or an invoice waits for your approval. Every action is logged on their task board."
  },
  {
   "q": "What if they aren't sure how to categorize something?",
   "a": "They flag the transaction for you or your accountant instead of guessing, especially when the choice affects taxes."
  },
  {
   "q": "Can they chase overdue invoices?",
   "a": "Yes. They build the aging report and draft polite reminders in your voice. Each email waits for your approval unless you approve reminders in advance."
  },
  {
   "q": "Do I still need an accountant?",
   "a": "For taxes, filings and formal advice, yes. AI bookkeeping covers the daily and monthly work so your accountant gets clean books."
  },
  {
   "q": "Is an AI bookkeeper a good fit for a startup?",
   "a": "Yes. Startups use them to keep the books current from day one: transactions categorized, accounts reconciled and a clean package for their accountant each month."
  },
  {
   "q": "How is bookkeeper AI different from accounting software?",
   "a": "Accounting software stores your books and suggests matches. Your AI bookkeeper does the work inside it: they categorize, reconcile, chase invoices and write a close report, and flag anything they are not sure about."
  },
  {
   "q": "Can I try an AI bookkeeper for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI bookkeeper and try a first task."
  },
  {
   "q": "What does an AI bookkeeper cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Bookkeeper in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Bookkeeper to work today",
  "body": "Hand them last month's statements and get back categorized books, a reconciliation report, and a short list of what needs your eyes."
 },
 "audience": {
  "title": "Who hires an AI bookkeeper",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Real numbers every week",
    "body": "Categorization, reconciliation and invoice tracking handed off, so the numbers are current every week, not just at tax time."
   },
   {
    "badge": "Small businesses",
    "title": "Clean books without the evening catch-up",
    "body": "Current books and a steady month-end close, kept up between the work that runs the business."
   },
   {
    "badge": "Mid-size companies",
    "title": "A cleaner close for the finance team",
    "body": "Categorization, reconciliations and invoice follow-up done before your accountant or controller reviews them."
   },
   {
    "badge": "Agencies",
    "title": "Books for every client",
    "body": "Agencies and firms keep separate, organized books for each client, each with its own month-end close."
   },
   {
    "badge": "Startups",
    "title": "Numbers ready for the board",
    "body": "Clean monthly books and a plain summary your accountant and investors can read."
   },
   {
    "badge": "Operators with several entities",
    "title": "Books for every entity",
    "body": "Separate, organized books for each entity, each with its own close."
   }
  ]
 }
};

export default content;
